import React, { useState, useEffect } from 'react';
import { API, COLORS } from '../utils/constants';
import { r1 } from '../utils/helpers';
import AlimentoWizard from '../components/AlimentoWizard';
import SwipeableRow from '../components/SwipeableRow';
import Popup from '../components/Popup';
// Helper to clean decimal input - preserves "0." at start
const cleanDecimal = (v) => {
  if (!v) return '';
  let cleaned = v.replace(/[^0-9.,]/g, '');
  if (cleaned.match(/^0+[.,]/)) cleaned = cleaned.replace(/^0+/, '0');
  cleaned = cleaned.replace(',', '.');
  const parts = cleaned.split('.');
  if (parts.length > 2) cleaned = parts[0] + '.' + parts.slice(1).join('');
  return cleaned;
};


const GEO_ENABLED = false;

export default function BaseDatosScreen() {
  const [alimentos, setAlimentos] = useState([]);
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);
  const [editando, setEditando] = useState(null);
  const [searching, setSearching] = useState(false);
  const [showWizardBase, setShowWizardBase] = useState(false);
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };



  const cargar = () => {
    fetch(API + "/alimentos/todos", { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        const sorted = (data || []).sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));
        setAlimentos(sorted);
      })
      .catch(() => {});
  };

  useEffect(() => { cargar(); }, []);

  const filtrados = alimentos.filter(a =>
    a.nombre.toLowerCase().includes(query.toLowerCase())
  );

  const borrar = async (id) => {
    await fetch(API + `/alimentos/${id}`, { method: "DELETE", credentials: "include" }).catch(() => {});
    setSelected(null);
    cargar();
    showToast("Alimento eliminado");
  };

  const guardarEdicion = async () => {
    await fetch(API + `/alimentos/${editando.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(editando),
    }).catch(() => {});
    setEditando(null);
    setSelected(null);
    cargar();
    showToast("Alimento actualizado");
  };

  const guardarNuevoDesdeWizard = async (data) => {
    let lat = null, lon = null;
    if (GEO_ENABLED) {
      try {
        const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { timeout: 4000 }));
        lat = pos.coords.latitude; lon = pos.coords.longitude;
      } catch {}
    }
    await fetch(API + "/alimentos", {
      method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include",
      body: JSON.stringify({
        nombre: data.nombre, calorias: data.calorias, proteina: data.proteina,
        carbos: data.carbos, grasa: data.grasa, fuente: "manual",
        latitud: lat, longitud: lon,
        tipo_medida: data.tipo_medida, tipo_cantidad: data.tipo_cantidad,
        peso_unidad: data.peso_unidad, densidad: data.densidad, nombre_unidad: data.nombre_unidad,
      }),
    }).catch(() => {});
    setShowWizardBase(false);
    cargar();
    showToast("Alimento añadido");
  };

  return (
    <div style={{ padding: "0 16px 100px" }}>
      {toast && <div style={{ position: "fixed", top: 60, left: "50%", transform: "translateX(-50%)", background: COLORS.accent, color: "#fff", padding: "10px 20px", borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999 }}>{toast}</div>}
      <div style={{ paddingTop: 'calc(var(--sat, env(safe-area-inset-top, 0px)) + 14px)', paddingBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <p style={{ color: COLORS.accent, fontSize: 10, letterSpacing: 2, textTransform: "uppercase", margin: "0 0 4px", fontWeight: 800 }}>Alimentos guardados</p>
          <h1 style={{ color: "#fff", fontSize: 28, fontWeight: 900, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: -1, lineHeight: 1.1 }}>Base</h1>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => setShowWizardBase(true)} style={{ background: `linear-gradient(135deg, ${COLORS.accent}, #e55a2b)`, border: "none", borderRadius: 14, padding: "10px 18px", color: "#fff", fontSize: 14, fontWeight: 800, cursor: "pointer" }}>Añadir</button>
        </div>
      </div>

      <input
        value={query}
        onChange={e => setQuery(e.target.value)}
        placeholder="Buscar alimento..."
        style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, padding: "12px 16px", color: "#fff", fontSize: 14, outline: "none", boxSizing: "border-box", marginBottom: 16 }}
      />

      <p style={{ color: COLORS.textMuted, fontSize: 12, margin: "0 0 12px" }}>{filtrados.length} alimento{filtrados.length !== 1 ? "s" : ""}</p>

      <div style={{ position: "relative" }}>
        {filtrados.map((a, i) => {
          const firstLetter = a.nombre.charAt(0).toUpperCase();
          const isFirstOfLetter = i === 0 || filtrados[i - 1].nombre.charAt(0).toUpperCase() !== firstLetter;
          
          return (
            <SwipeableRow key={a.id || i} onDelete={() => borrar(a.id)}>
              <div id={isFirstOfLetter ? `letra-${firstLetter}` : undefined} onClick={() => setSelected(a)} style={{ background: "rgba(255,255,255,0.04)", backdropFilter: "blur(10px)", borderRadius: 12, padding: "14px 16px", border: "1px solid rgba(255,255,255,0.07)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", marginRight: 24 }}>
                <span style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>{a.nombre}</span>
                <span style={{ color: "rgba(255,255,255,0.35)", fontSize: 12 }}>{r1(a.calorias)} kcal</span>
              </div>
            </SwipeableRow>
          );
        })}
        
        {/* Abecedario Flotante */}
        {filtrados.length > 15 && (
          <div style={{ position: "fixed", right: 2, top: "55%", transform: "translateY(-50%)", display: "flex", flexDirection: "column", alignItems: "center", zIndex: 100 }}>
            {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map(l => (
              <div key={l} onClick={() => {
                const el = document.getElementById(`letra-${l}`);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
              }} style={{ fontSize: 9, fontWeight: 800, color: COLORS.textMuted, padding: "2px 6px", margin: "1px 0", cursor: "pointer" }}>
                {l}
              </div>
            ))}
          </div>
        )}
      </div>

      {filtrados.length === 0 && (
        <div style={{ textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>◈</div>
          <p style={{ color: COLORS.textMuted }}>No hay alimentos</p>
        </div>
      )}

      {/* Modal detalle */}
      {selected && !editando && (
        <Popup type="centered" onClose={() => setSelected(null)} zIndex={500}>
            <div style={{ marginBottom: 24, textAlign: "center" }}>
              <span style={{ color: COLORS.text, fontSize: 22, fontWeight: 900, lineHeight: 1.2 }}>{selected.nombre}</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
              {[["Calorías", r1(selected.calorias), "kcal", COLORS.accent], ["Proteína", r1(selected.proteina), "g", COLORS.blue], ["Carbos", r1(selected.carbos), "g", COLORS.green], ["Grasa", r1(selected.grasa), "g", COLORS.purple]].map(([l, v, u, c]) => (
                <div key={l} style={{ background: COLORS.bg, borderRadius: 16, padding: 16, textAlign: "center", border: `1px solid ${c}20`, boxShadow: `inset 0 2px 10px rgba(0,0,0,0.2)` }}>
                  <div style={{ color: c, fontSize: 24, fontWeight: 900, letterSpacing: -0.5 }}>{v}<span style={{ fontSize: 12, fontWeight: 600, marginLeft: 2 }}>{u}</span></div>
                  <div style={{ color: COLORS.textMuted, fontSize: 10, marginTop: 4, letterSpacing: 0.5, fontWeight: 600 }}>{l} / 100g</div>
                </div>
              ))}
            </div>
            {selected.latitud && selected.longitud && (
              <div onClick={e => e.stopPropagation()} style={{ background: COLORS.bg, borderRadius: 14, padding: "14px", marginBottom: 20, display: "flex", alignItems: "center", gap: 12, border: `1px solid ${COLORS.border}` }}>
                <span style={{ fontSize: 20 }}>📍</span>
                <div>
                  <div style={{ color: COLORS.textMuted, fontSize: 11, letterSpacing: 0.5, marginBottom: 4, fontWeight: 700 }}>UBICACIÓN AL AÑADIR</div>
                  <a href={`https://maps.apple.com/?ll=${selected.latitud},${selected.longitud}`} target="_blank" rel="noreferrer" style={{ color: COLORS.blue, fontSize: 13, fontWeight: 700, textDecoration: "none" }}>
                    {selected.latitud.toFixed(5)}, {selected.longitud.toFixed(5)}
                  </a>
                </div>
              </div>
            )}
            <div style={{ display: "flex", gap: 12 }}>
              <button onClick={(e) => { e.stopPropagation(); setEditando({ ...selected }); }} style={{ flex: 1, padding: 16, borderRadius: 14, background: COLORS.bg, border: `1px solid ${COLORS.border}`, color: COLORS.text, fontSize: 15, fontWeight: 800, cursor: "pointer" }}>✎ Editar</button>
              <button onClick={(e) => { e.stopPropagation(); borrar(selected.id); }} style={{ flex: 1, padding: 16, borderRadius: 14, background: "#ff2d5520", border: "1px solid #ff2d5540", color: "#ff2d55", fontSize: 15, fontWeight: 800, cursor: "pointer" }}>🗑 Borrar</button>
            </div>
        </Popup>
      )}

      {/* Wizard añadir */}
      {showWizardBase && (
        <AlimentoWizard modoNutricion={false} onClose={() => setShowWizardBase(false)} onComplete={guardarNuevoDesdeWizard} />
      )}

      {/* Modal editar */}
      {editando && (
        <Popup type="sheet" onClose={() => setEditando(null)} title="Editar alimento" zIndex={500}>
            {[["Nombre", "nombre", "text"], ["Calorías (por 100g)", "calorias", "decimal"], ["Proteína (por 100g)", "proteina", "decimal"], ["Carbos (por 100g)", "carbos", "decimal"], ["Grasa (por 100g)", "grasa", "decimal"]].map(([label, key, type]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={{ color: COLORS.textMuted, fontSize: 10, letterSpacing: 1, display: "block", marginBottom: 4 }}>{label.toUpperCase()}</label>
                <input
                  type={type === "decimal" ? "text" : type}
                  inputMode={type === "decimal" ? "decimal" : "text"}
                  value={editando[key] || ""}
                  onChange={e => { let v = type === "decimal" ? cleanDecimal(e.target.value) : e.target.value; setEditando(p => ({ ...p, [key]: type === "decimal" ? parseFloat(v) || 0 : v })); }}
                  style={{ width: "100%", background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: "10px 12px", color: COLORS.text, fontSize: 15, outline: "none", boxSizing: "border-box" }}
                />
              </div>
            ))}
            <div style={{ marginBottom: 14 }}>
              <label style={{ color: COLORS.textMuted, fontSize: 10, letterSpacing: 1, display: "block", marginBottom: 8 }}>TIPO DE MEDIDA</label>
              <div style={{ display: "flex", gap: 8 }}>
                {[["peso", "⚖️ Peso"], ["unidad", "🥚 Unidad"], ["liquido", "💧 Líquido"]].map(([t, lbl]) => (
                  <button key={t} onClick={() => setEditando(p => ({ ...p, tipo_medida: t, tipo_cantidad: t === "unidad" ? "unidad" : "peso" }))} style={{ flex: 1, padding: "9px 4px", borderRadius: 10, border: "none", background: (editando.tipo_medida || "peso") === t ? COLORS.accent : COLORS.bg, color: (editando.tipo_medida || "peso") === t ? "#fff" : COLORS.textMuted, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{lbl}</button>
                ))}
              </div>
            </div>
            {(editando.tipo_medida || "peso") === "unidad" && (<>
              <div style={{ marginBottom: 14 }}>
                <label style={{ color: COLORS.textMuted, fontSize: 10, letterSpacing: 1, display: "block", marginBottom: 4 }}>GRAMOS POR UNIDAD</label>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ color: COLORS.textMuted, fontSize: 10, letterSpacing: 1, display: "block", marginBottom: 4 }}>NOMBRE UNIDAD (opcional)</label>
                <input type="text" inputMode="decimal" value={editando.peso_unidad || ""} onChange={e => setEditando(p => ({ ...p, peso_unidad: parseFloat(cleanDecimal(e.target.value)) || null }))} placeholder="Ej: 60" style={{ width: "100%", background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: "10px 12px", color: COLORS.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
              </div>
            </>)}
            {(editando.tipo_medida || "peso") === "liquido" && (
              <div style={{ marginBottom: 14 }}>
                <label style={{ color: COLORS.textMuted, fontSize: 10, letterSpacing: 1, display: "block", marginBottom: 4 }}>DENSIDAD (g/ml) — agua=1.0, aceite=0.92, leche=1.03</label>
                <input type="text" inputMode="decimal" value={editando.densidad || "1.0"} onChange={e => setEditando(p => ({ ...p, densidad: parseFloat(cleanDecimal(e.target.value)) || 1.0 }))} style={{ width: "100%", background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: "10px 12px", color: COLORS.text, fontSize: 15, outline: "none", boxSizing: "border-box" }} />
              </div>
            )}
            <button
              onClick={async () => {
                if (!editando?.nombre) return;
                setSearching(true);
                try {
                  const res = await fetch(API + '/alimentos/online?q=' + encodeURIComponent(editando.nombre)).then(r => r.json()).catch(() => ({error: 'Error de red', products: []}));
                  const products = res.products || [];
                  const first = products.length > 0 ? products[0] : null;
                  const fuente = res.fuente || 'desconocida';
                  if (res.error) {
                    alert('No se pudieron obtener datos. Error: ' + res.error);
                  } else if (first && first.calorias) {
                    // Mostrar toast con la fuente
                    const fuenteLabel = fuente === 'claude' ? 'Claude IA' : fuente === 'usda' ? 'Base de datos USDA' : fuente === 'openfoodfacts' ? 'OpenFoodFacts' : fuente;
                    console.log('Datos de ' + fuenteLabel);
                    setEditando(p => ({
                      ...p,
                      calorias: parseFloat(cleanDecimal(String(first.calorias))) || 0,
                      proteina: parseFloat(cleanDecimal(String(first.proteina || 0))) || 0,
                      carbos: parseFloat(cleanDecimal(String(first.carbos || 0))) || 0,
                      grasa: parseFloat(cleanDecimal(String(first.grasa || 0))) || 0,
                    }));
                  } else {
                    alert('No se encontraron datos en internet para este alimento. La base de datos puede estar temporalmente no disponible.');
                  }
                } catch {
                  alert('Error al buscar datos');
                } finally {
                  setSearching(false);
                }
              }}
              style={{ width: "100%", padding: 14, borderRadius: 12, background: 'rgba(0,218,243,0.15)', border: '1px solid rgba(0,218,243,0.4)', color: '#00daf3', cursor: searching ? 'default' : 'pointer', fontWeight: 700, fontSize: 14, marginBottom: 12 }}
            >
              🔄 {searching ? 'Buscando...' : 'Buscar datos en internet'}
            </button>
            <button onClick={guardarEdicion} style={{ width: "100%", padding: 16, borderRadius: 14, background: `linear-gradient(135deg, ${COLORS.accent}, #e55a2b)`, border: "none", color: "#fff", fontSize: 15, fontWeight: 800, cursor: "pointer" }}>GUARDAR</button>
        </Popup>
      )}

    </div>
  );
}
